"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var DomWidgets_1 = require("./DomWidgets");
var Declarative_1 = require("../utils/Declarative");
var TabStyles_1 = require("../styles/TabStyles");
var InteractiveDom_1 = require("../utils/InteractiveDom");
var DynamicThemeComponent_1 = require("./DynamicThemeComponent");
var StackingComponent_1 = require("../utils/StackingComponent");
var getStyles = function () {
    return {
        Glass: {
            position: 'fixed',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            padding: 0,
            margin: 0,
            pointerEvents: 'auto'
        },
        Clear: {
            backgroundColor: TabStyles_1.TabStyles.Colors.White,
            opacity: TabStyles_1.TabStyles.Opacity.ClearGlass
        },
        Opaque: {
            backgroundColor: TabStyles_1.TabStyles.Colors.OpaqueGlass,
            opacity: TabStyles_1.TabStyles.Opacity.OpaqueGlass
        }
    };
};
var GlassWidgetBase = /** @class */ (function (_super) {
    tslib_1.__extends(GlassWidgetBase, _super);
    function GlassWidgetBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleKeyDown = function (e) {
            if ((e.key === 'Tab' && e.shiftKey) ||
                (e.key === 'Escape' && _this.props.handleEscape)) {
                e.preventDefault();
                e.stopPropagation();
            }
        };
        _this.handleKeyUp = function (e) {
            if (_this.props.handleEscape && e.key === 'Escape') {
                _this.props.handleEscape();
                e.preventDefault();
                e.stopPropagation();
            }
        };
        return _this;
    }
    GlassWidgetBase.prototype.render = function () {
        var _this = this;
        var styles = getStyles();
        var style = tslib_1.__assign(tslib_1.__assign({}, styles.Glass), (this.props.isTransparent ? styles.Clear : styles.Opaque));
        return react_1.createElement(InteractiveDom_1.InteractiveDomWrapper, {
            pointerClick: function (e) {
                e.preventDefault();
                if (_this.props.handleClick) {
                    _this.props.handleClick();
                }
            }
        }, react_1.createElement(DomWidgets_1.Block, {
            style: style,
            onKeyDown: this.handleKeyDown,
            onKeyUp: this.handleKeyUp,
            tabIndex: 0,
            'data-tb-test-id': Declarative_1.testId(this.props.testId, 'Glass')
        }));
    };
    return GlassWidgetBase;
}(DynamicThemeComponent_1.DynamicThemeComponent));
exports.GlassWidgetBase = GlassWidgetBase;
var GlassWidget = StackingComponent_1.StackingComponentHOC(GlassWidgetBase);
exports.GlassWidget = GlassWidget;
//# sourceMappingURL=GlassWidget.js.map